export default __webpack_public_path__ + "static/9-00dc7110c9af2e1f234d2710e33a365e.jpg";